/**
 * Home Hero Slider
 * Features:
 * - Support for both images and videos
 * - Navigation arrows (keyboard, touch, click)
 */

function initHomeHeroSlider(heroElement, speed, totalSlides, autoplay = true) {
  if (!heroElement || totalSlides <= 1) return;
  
  // Get slider elements
  const slides = heroElement.querySelectorAll('.home-hero__slide');
  const prevBtn = document.getElementById('prevSlide');
  const nextBtn = document.getElementById('nextSlide');
  
  // Set up state variables
  let currentIndex = 0;
  let isTransitioning = false;
  let autoplayInterval = null;
  
  // Find initial active slide
  for (let i = 0; i < slides.length; i++) {
    if (slides[i].classList.contains('home-hero__slide--active')) {
      currentIndex = i;
      break;
    }
  }
  
  // Initialize videos
  initVideos();
  
  // Set up navigation
  if (prevBtn) {
    prevBtn.addEventListener('click', goToPrevSlide);
  }
  
  if (nextBtn) {
    nextBtn.addEventListener('click', goToNextSlide);
  }
  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowRight') {
      goToNextSlide();
    } else if (e.key === 'ArrowLeft') {
      goToPrevSlide();
    }
  });
  
  // Touch swipe support
  let touchStartX = 0;
  let touchEndX = 0;
  const minSwipeDistance = 50;
  
  heroElement.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });
  
  heroElement.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, { passive: true });
  
  function handleSwipe() {
    const swipeDistance = touchEndX - touchStartX;
    
    if (swipeDistance > minSwipeDistance) {
      // Swipe right, go to previous slide
      goToPrevSlide();
    } else if (swipeDistance < -minSwipeDistance) {
      // Swipe left, go to next slide
      goToNextSlide();
    }
  }
  
  // Autoplay functionality
  function startAutoplay() {
    if (!autoplay || totalSlides <= 1) return;
    
    stopAutoplay(); // Clear any existing interval
    autoplayInterval = setInterval(() => {
      goToNextSlide();
    }, speed);
  }
  
  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }
  
  // Pause autoplay on user interaction
  if (prevBtn) {
    prevBtn.addEventListener('click', stopAutoplay);
  }
  
  if (nextBtn) {
    nextBtn.addEventListener('click', stopAutoplay);
  }
  
  heroElement.addEventListener('touchstart', stopAutoplay, { passive: true });
  
  // Start autoplay if enabled
  startAutoplay();
  
  
  // Initialize videos
  function initVideos() {
    const videos = heroElement.querySelectorAll('[data-video]');
    videos.forEach(video => {
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('loop', '');
    });
  }
  
  function goToNextSlide() {
    if (isTransitioning) return;
    isTransitioning = true;
    
    // Hide current slide
    slides[currentIndex].classList.remove('home-hero__slide--active');
    
    // Pause current video if any
    const currentVideo = slides[currentIndex].querySelector('video');
    if (currentVideo) {
      currentVideo.pause();
      currentVideo.currentTime = 0;
    }
    
    // Update index
    currentIndex = (currentIndex + 1) % totalSlides;
    
    // Show new slide
    slides[currentIndex].classList.add('home-hero__slide--active');
    
    // Play new video if any
    const newVideo = slides[currentIndex].querySelector('video');
    if (newVideo) {
      try {
        const playPromise = newVideo.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log('Video play error:', error);
          });
        }
      } catch (error) {
        console.log('Video play error:', error);
      }
    }
    
    
    // Reset transition lock
    setTimeout(() => {
      isTransitioning = false;
    }, 500);
  }
  
  function goToPrevSlide() {
    if (isTransitioning) return;
    isTransitioning = true;
    
    // Hide current slide
    slides[currentIndex].classList.remove('home-hero__slide--active');
    
    // Pause current video if any
    const currentVideo = slides[currentIndex].querySelector('video');
    if (currentVideo) {
      currentVideo.pause();
      currentVideo.currentTime = 0;
    }
    
    // Update index
    currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    
    // Show new slide
    slides[currentIndex].classList.add('home-hero__slide--active');
    
    // Play new video if any
    const newVideo = slides[currentIndex].querySelector('video');
    if (newVideo) {
      try {
        const playPromise = newVideo.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log('Video play error:', error);
          });
        }
      } catch (error) {
        console.log('Video play error:', error);
      }
    }
    
    
    // Reset transition lock
    setTimeout(() => {
      isTransitioning = false;
    }, 500);
  }
  
}